import { useDispatch, useSelector } from "react-redux";
import styles from "../styles/ui/SideMenu.module.css";
import { Drawer } from "antd";
import { closeSideMenu } from "../redux/ui/uiSlice";

function SideMenu({
  children,
  title = "",
  closeHandler,
  className = "",
  scope,
}) {
  const {
    ui: { openSideMenu, sideMenuKey, sideMenuScope },
  } = useSelector((state) => state);

  const dispatch = useDispatch();

  const close = () => {
    if (closeHandler) {
      closeHandler();
    }
    dispatch(closeSideMenu());
  };

  const shouldRender = openSideMenu && sideMenuScope === scope;

  return (
    <Drawer
      open={shouldRender}
      title={title}
      closable={{ "aria-label": "Close Button" }}
      onClose={close}
      rootClassName={`${styles.customDrawer} ${className}`}
      maskClosable={false}
    >
      {children}
    </Drawer>
  );
}

export default SideMenu;
